<template>
  <div class="main-bolsa mb-4">
    <b-jumbotron class="title_page">
      <h1 class="text-center font-weight-bold">Política de Privacidade</h1>
    </b-jumbotron>
    <bread-cpv class="adjustment-breadcrumb"></bread-cpv>

    <b-container fluid="xl" class="content-bolsa-font">
      <div class="privacy-policy">
        <h2>Política de Privacidade e Uso de Dados – CPV Educacional</h2>
        <hr />

        <h3>1. Introdução</h3>
        <p>
          O CPV Educacional compromete-se a proteger a privacidade dos usuários e assegurar que o tratamento de dados
          pessoais esteja em conformidade com a legislação vigente sobre proteção de dados pessoais.
        </p>
        <p>
          Esta Política de Privacidade descreve quais dados pessoais coletamos, como os utilizamos, com quem os
          compartilhamos e os direitos que você possui sobre esses dados. Recomendamos que você leia também os nossos
          Termos de Uso, disponíveis [link].
        </p>
        <p>
          Para dúvidas ou esclarecimentos adicionais, contate nosso Encarregado de Proteção de Dados (DPO) pelo e-mail
          contato@cpv.com.br.
        </p>

        <h3>2. Coleta e Uso de Dados</h3>
        <p>Ao utilizar a Plataforma, coletamos informações pessoais como:</p>
        <ul>
          <li>
            <strong>Informações de Registro:</strong> nome, e-mail, telefone, senha e dados de verificação de
            identidade.
          </li>
          <li><strong>Informações de Perfil:</strong> escola, exames pretendidos, foto e localização (opcionais).</li>
          <li><strong>Atendimento ao Cliente:</strong> nome, e-mail e conteúdo das comunicações.</li>
          <li><strong>Notificações Push:</strong> atualizações e mensagens relevantes configuráveis pelo usuário.</li>
          <li>
            <strong>Dados Técnicos e de Uso:</strong> informações técnicas do dispositivo, IP, sistema operacional e
            estatísticas de uso.
          </li>
          <li><strong>Informações de Localização:</strong> dados geográficos aproximados autorizados pelo usuário.</li>
          <li><strong>Comunicação entre Usuários:</strong> registros das comunicações feitas pela Plataforma.</li>
          <li>
            <strong>Cookies e Tecnologias Similares:</strong> utilizados para melhorar a experiência e análise de uso.
          </li>
        </ul>

        <p>As informações coletadas são utilizadas para:</p>
        <ul>
          <li>Personalizar a experiência do usuário;</li>
          <li>Fornecer suporte técnico e responder dúvidas;</li>
          <li>Prevenir e investigar fraudes ou atividades ilícitas;</li>
          <li>Cumprir obrigações legais ou regulatórias;</li>
          <li>Realizar atividades de marketing e comunicação.</li>
        </ul>

        <p>
          Compartilhamos seus dados pessoais com prestadores de serviços que nos auxiliam na prestação dos serviços,
          exigindo confidencialidade.
        </p>
        <p>Poderemos compartilhar seus dados pessoais ainda nas seguintes situações:</p>
        <ul>
          <li>Com empresas do mesmo grupo econômico;</li>
          <li>Em caso de transações empresariais (venda, fusão, cisão, incorporação);</li>
          <li>Com autoridades competentes mediante requisição legal;</li>
          <li>Com outros usuários da Plataforma, conforme funcionalidades previstas.</li>
        </ul>

        <h3>3. Segurança</h3>
        <p>
          Adotamos medidas técnicas e administrativas apropriadas para proteger os dados pessoais contra acessos não
          autorizados, perda ou destruição acidental.
        </p>
        <p>
          Apesar dos esforços, nenhuma transmissão pela internet é completamente segura. Você deve proteger suas
          credenciais e nos informar sobre qualquer suspeita de uso não autorizado.
        </p>

        <h3>4. Seus Direitos</h3>
        <p>Você pode exercer os seguintes direitos sobre seus dados pessoais:</p>
        <ul>
          <li>Confirmação e acesso aos seus dados;</li>
          <li>Correção de dados incompletos ou desatualizados;</li>
          <li>Anonimização, bloqueio ou eliminação de dados desnecessários ou excessivos;</li>
          <li>Portabilidade dos dados;</li>
          <li>Revogação do consentimento, quando aplicável;</li>
          <li>Informação sobre as consequências de não fornecer consentimento;</li>
          <li>Oposição ao tratamento dos dados.</li>
        </ul>

        <h3>5. Exercício dos Seus Direitos</h3>
        <p>Para exercer seus direitos, envie sua solicitação ao nosso DPO pelo e-mail contato@cpv.com.br.</p>
        <p>Solicitaremos informações adicionais para verificar sua identidade antes de atender ao pedido.</p>

        <h3>6. Alterações na Política</h3>
        <p>
          Podemos atualizar esta Política periodicamente para refletir mudanças legislativas ou melhorias em nossas
          práticas. Você será informado das atualizações por meio da Plataforma.
        </p>
        <p><em>Última atualização: 22 de maio de 2025.</em></p>

        <h3>Glossário</h3>
        <ul>
          <li>
            <strong>Dados Pessoais:</strong> informações relacionadas a uma pessoa natural identificada ou
            identificável.
          </li>
          <li>
            <strong>Consentimento:</strong> manifestação livre, informada e inequívoca do titular sobre o tratamento dos
            dados.
          </li>
          <li><strong>Controlador:</strong> entidade que toma decisões sobre o tratamento dos dados pessoais.</li>
          <li>
            <strong>Tratamento:</strong> operação realizada com dados pessoais, incluindo coleta, armazenamento e
            utilização.
          </li>
          <li><strong>Titular:</strong> pessoa natural a quem se referem os dados pessoais.</li>
          <li><strong>LGPD:</strong> Lei Geral de Proteção de Dados (Lei nº 13.709/2018).</li>
        </ul>
      </div>
    </b-container>
  </div>
</template>

<script>
import BreadCpv from "@/components/global/bread-cpv.vue";
export default {
  name: "PrivacyPolicy",
  components: { BreadCpv },
  data() {
    return {
      //
    };
  },
  created: function () {
    //
  },
  beforeDestroy: function () {
    //
  },
  methods: {
    //
  },
};
</script>

<style lang="scss" scoped>
.privacy-policy {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #000;
}
.privacy-policy h2 {
  text-align: right;
}
.privacy-policy h3 {
  margin-top: 24px;
}
.privacy-policy ul {
  margin-left: 20px;
  list-style-type: disc;
}

@media (min-width: 1200px) {
  .main-bolsa {
    width: 100%;
    height: auto;
  }

  .title_page {
    margin: -8px 0px 0px !important;
    padding: 55px 0px 50px;
    background-repeat: repeat;
    background-position: center;
    background-color: rgb(239, 72, 87);
    background-image: url("https://d1jehvsxq7tgfk.cloudfront.net/sitecpv/images/cpv-fundo-4.png");
    background-size: 30%;
    // background-attachment: fixed;
    object-fit: cover;
    border-radius: 0;

    h1 {
      font-size: 51px;
      font-weight: 700;
      color: #ffffff;
      text-transform: uppercase;
      font-family: "FF Clan Pro", sans-serif;
    }
  }

  .header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgb(58, 28, 83);
  }

  .header h4 {
    font-size: 26px;
    font-weight: bold;
    line-height: 1.385;
    letter-spacing: 0.81px;
    text-transform: uppercase;
    text-align: center;
  }

  .header h4 .emphasis {
    color: rgb(239, 72, 87);
  }

  .content-bolsa {
    width: 100%;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: column;
    color: #333333;
  }

  .content-bolsa h6,
  h5 {
    font-size: 20px;
    color: rgb(58, 28, 83);
  }

  .content-bolsa h6 .emphasis,
  .content-bolsa h5 .emphasis {
    color: rgb(239, 72, 87);
  }

  .content-bolsa span {
    font-weight: bold;
  }

  .content-bolsa .info-prova {
    width: 100%;
    height: auto;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: column;
  }

  .content-bolsa .info-prova h4 {
    font-size: 22px;
    font-weight: bold;
  }

  .content-bolsa .info-prova ul {
    margin-left: 2%;
  }
  .content-bolsa .info-prova ul li span {
    font-weight: bold;
  }
  .content-bolsa .info-prova ul li {
    padding: 5px 0px;
  }
  .content-bolsa .info-prova ul li a {
    font-weight: bold;
    color: #333333;
    text-decoration: none;
  }
  .content-bolsa .info-prova ul li a:hover {
    font-weight: bold;
    color: rgb(239, 72, 87);
    text-decoration: none;
    transition: all 0.3s ease;
  }

  .button-inscricao .btn_insc {
    height: 56px;
    width: 35% !important;
  }

  .button-inscricao .btn_inscricao {
    border: 2px solid rgb(239, 72, 87);
    border-radius: 5px;
    background-color: rgb(239, 72, 87);
    // box-shadow: 0px 0px 30px rgba(1, 41, 141, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
  }

  .button-inscricao .btn_inscricao span {
    color: #ffffff;
    text-transform: uppercase;
  }

  .content-bolsa-font {
    font-family: "Clan-Book Book", sans-serif;
    font-size: 16px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1200px) {
  .main-bolsa {
    width: 100%;
    height: auto;
    font-size: 16px;
    margin: 80px 0;
  }

  .title_page {
    margin: -20px 0px -10px;
    padding: 55px 0px 50px;
    background-repeat: repeat;
    background-position: center;
    background-color: rgb(259, 72, 87);
    background-image: url("https://d1jehvsxq7tgfk.cloudfront.net/sitecpv/images/cpv-fundo-4.png");
    border-radius: 0;
  }

  .title_page h1 {
    font-size: 41px;
    font-weight: 700;
    color: #ffffff;
    text-transform: uppercase;
    font-family: "FF Clan Pro", sans-serif;
  }

  .adjustment-breadcrumb {
    margin: 10px 0 50px !important;
  }

  .header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .header h4 {
    font-size: 26px;
    font-weight: bold;
    line-height: 1.385;
    letter-spacing: 0.81px;
    text-transform: uppercase;
    text-align: center;
    color: rgb(58, 28, 83);
  }

  .header h4 .emphasis {
    color: rgb(239, 72, 87);
  }

  .content-bolsa {
    width: 100%;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: column;
    color: #333333;
  }

  .content-bolsa h6,
  h5 {
    font-size: 20px;
    color: rgb(58, 28, 83);
  }

  .content-bolsa h6 .emphasis,
  .content-bolsa h5 .emphasis {
    color: rgb(239, 72, 87);
  }

  .content-bolsa span {
    font-weight: bold;
  }

  .content-bolsa .info-prova {
    width: 100%;
    height: auto;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: column;
  }

  .content-bolsa .info-prova h4 {
    font-size: 22px;
    font-weight: bold;
  }

  .content-bolsa .info-prova ul {
    margin-left: 2%;
  }
  .content-bolsa .info-prova ul li span {
    font-weight: bold;
  }
  .content-bolsa .info-prova ul li {
    padding: 5px 0px;
  }
  .content-bolsa .info-prova ul li a {
    font-weight: bold;
    color: #333333;
    text-decoration: none;
  }
  .content-bolsa .info-prova ul li a:hover {
    font-weight: bold;
    color: rgb(239, 72, 87);
    text-decoration: none;
    transition: all 0.3s ease;
  }

  .button-inscricao .btn_insc {
    height: 56px;
    width: 35% !important;
  }

  .button-inscricao .btn_inscricao {
    border: 2px solid rgb(239, 72, 87);
    border-radius: 5px;
    background-color: rgb(239, 72, 87);
    // box-shadow: 0px 0px 30px rgba(1, 41, 141, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
  }

  .button-inscricao .btn_inscricao span {
    color: #ffffff;
    text-transform: uppercase;
  }

  .content-bolsa-font {
    font-family: "Clan-Book Book", sans-serif;
    font-size: 16px;
  }
}

@media only screen and (max-width: 768px) {
  .main-bolsa {
    width: 100%;
    height: auto;
    font-family: "Clan-Book Book", sans-serif;
    font-size: 16px;
  }

  .title_page {
    margin: -10px 0px -10px;
    padding: 55px 0px 50px;
    background-repeat: repeat;
    background-position: center;
    background-color: rgb(259, 72, 87);
    background-image: url("https://d1jehvsxq7tgfk.cloudfront.net/sitecpv/images/cpv-fundo-4.png");
    border-radius: 0;
  }

  .title_page h1 {
    font-size: 41px;
    font-weight: 700;
    color: #ffffff;
    text-transform: uppercase;
  }

  .adjustment-breadcrumb {
    margin-top: 0px !important;
  }

  .header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .header h4 {
    font-size: 26px;
    font-weight: bold;
    line-height: 1.385;
    letter-spacing: 0.81px;
    text-transform: uppercase;
    text-align: center;
    color: rgb(58, 28, 83);
  }

  .header h4 .emphasis {
    color: rgb(239, 72, 87);
  }

  .content-bolsa {
    width: 100%;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: column;
    color: #333333;
  }

  .content-bolsa h6,
  h5 {
    font-size: 20px;
    color: rgb(58, 28, 83);
  }

  .content-bolsa h6 .emphasis,
  .content-bolsa h5 .emphasis {
    color: rgb(239, 72, 87);
  }

  .content-bolsa span {
    font-weight: bold;
  }

  .content-bolsa .info-prova {
    width: 100%;
    height: auto;
    display: flex;
    align-items: left;
    justify-content: left;
    flex-direction: column;
  }

  .content-bolsa .info-prova h4 {
    font-size: 22px;
    font-weight: bold;
  }

  .content-bolsa .info-prova ul {
    margin-left: 2%;
  }
  .content-bolsa .info-prova ul li span {
    font-weight: bold;
  }
  .content-bolsa .info-prova ul li {
    padding: 5px 0px;
  }
  .content-bolsa .info-prova ul li a {
    font-weight: bold;
    color: #333333;
    text-decoration: none;
  }
  .content-bolsa .info-prova ul li a:hover {
    font-weight: bold;
    color: rgb(239, 72, 87);
    text-decoration: none;
    transition: all 0.3s ease;
  }

  .button-inscricao .btn_insc {
    height: 56px;
    width: 35% !important;
  }

  .button-inscricao .btn_inscricao {
    border: 2px solid rgb(239, 72, 87);
    border-radius: 5px;
    background-color: rgb(239, 72, 87);
    // box-shadow: 0px 0px 30px rgba(1, 41, 141, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
  }

  .button-inscricao .btn_inscricao span {
    color: #ffffff;
    text-transform: uppercase;
  }

  .content-bolsa-font {
    font-family: "Clan-Book Book", sans-serif;
    font-size: 16px;
  }
}
</style>
